import { render, staticRenderFns } from "./CreateFieldsSidebar.vue?vue&type=template&id=095f9c4d&scoped=true&"
import script from "./CreateFieldsSidebar.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CreateFieldsSidebar.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CreateFieldsSidebar.vue?vue&type=style&index=0&id=095f9c4d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095f9c4d",
  null
  
)

export default component.exports